import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useState, useEffect } from "react";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../../utils/common.service";
import { add_subcategory, get_category_details, show_manage_subcategory } from "../../../api/apiHandler";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import Select from "react-select";

export default function ManageSubcategoryShow({ isLoader }) {
    const navigate = useNavigate()
    const location = useLocation();
    const categoryId = location.state.categoryId;
    const subcategories = location.state.allData;
    const [categoryData, setCategoryData] = useState([]);

    const getFilteredCategories = (type) => {
        return subcategories
            .filter(cat => cat.category_for.split(',').includes(type))
            .map(cat => ({ value: cat.id, label: cat.category_name }));
    };

    const optionsClass = getFilteredCategories("class");
    const optionsClub = getFilteredCategories("club");
    const optionsQuiz = getFilteredCategories("quiz");
    const optionsCompetition = getFilteredCategories("competition");
    const [defaultsLoaded, setDefaultsLoaded] = useState(false);

    useEffect(() => {
        if (!categoryData || defaultsLoaded) return;

        const defaultClass = optionsClass.find(opt => opt.label === categoryData.is_class) || null;
        const defaultClub = optionsClub.find(opt => opt.label === categoryData.is_club) || null;
        const defaultQuiz = optionsQuiz.find(opt => opt.label === categoryData.is_quiz) || null;
        const defaultCompetition = optionsCompetition.find(opt => opt.label === categoryData.is_competition) || null;

        setFieldValue("class_subcategory", defaultClass);
        setFieldValue("club_subcategory", defaultClub);
        setFieldValue("quiz_subcategory", defaultQuiz);
        setFieldValue("competition_subcategory", defaultCompetition);

        categoryForm.setErrors({});
        categoryForm.setTouched({});

        setDefaultsLoaded(true);

    }, [categoryData, defaultsLoaded]);

    useEffect(() => {
        isLoader(true)
        get_category_details({ categoryId: categoryId }).then((response) => {
            if (response.code == 1) {
                setCategoryData(response?.data[0]);
                isLoader(false)
            } else {
                setCategoryData([])
                isLoader(false)
            }
        })
    },[]);


    const subcategorySchema = Yup.object({
        class_subcategory: Yup.object()
            .nullable()
            .required("Please select at least one Class subcategory"),

        club_subcategory: Yup.object()
            .nullable()
            .required("Please select at least one Club subcategory"),

        quiz_subcategory: Yup.object()
            .nullable()
            .required("Please select at least one Quiz subcategory"),

        competition_subcategory: Yup.object()
            .nullable()
            .required("Please select at least one Competition subcategory"),
        });

    const categoryForm = useFormik({
        initialValues: {
            class_subcategory: optionsClass.find(opt => opt.label === categoryData?.is_class) || null,
            club_subcategory: optionsClub.find(opt => opt.label === categoryData?.is_club) || null,
            quiz_subcategory: optionsQuiz.find(opt => opt.label === categoryData?.is_quiz) || null,
            competition_subcategory: optionsCompetition.find(opt => opt.label === categoryData?.is_competition) || null
        },
        enableReinitialize: true,
        validationSchema: subcategorySchema,
        validateOnBlur: false,
        validateOnChange: false,
        validateOnMount: false,
        onSubmit: async (data) => {
            console.log('data: ', data);
            isLoader(true)
            var obj = {
                class_subcategory: data?.class_subcategory?.label,
                club_subcategory: data?.club_subcategory?.label,
                competition_subcategory: data?.competition_subcategory?.label,
                quiz_subcategory: data?.quiz_subcategory?.label,
                category_id: categoryId
            }
            console.log('obj: ', obj);
            show_manage_subcategory(obj).then((resposnse) => {
                if (resposnse.code == 1) {
                    TOAST_SUCCESS(resposnse.message);
                    navigate(-1)
                    isLoader(false)
                } else {
                    TOAST_ERROR(resposnse.message);
                    isLoader(false)
                }
            });
        }
    });

    const { values, setFieldValue } = categoryForm;

    const handleBack = () => {
        navigate(-1);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <a className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </a>
                            <a href="index.php" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </a>
                        </div>
                    </div>
                </header>
                <div className="mx-5 mt-4">
                    <span onClick={handleBack}>
                        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                        </svg>
                        <span className="ms-2">Back</span>
                    </span>
                    <p className="d-flex justify-content-center fs-3 fw-500"> Show Manage SubCategory</p>
                    <div className="row align-items-center justify-content-center mt-5">
                        <div className="col-lg-6">
                            <div className="card border-purple p-4" >
                                <form onSubmit={categoryForm.handleSubmit} className="custom_form mt-4">
                                    
                                    <div className="form-group mb-4">
                                        <label className="mb-2">Class</label>
                                        <Select
                                            name="class_subcategory"
                                            value={values.class_subcategory}
                                            onChange={(option) => setFieldValue("class_subcategory", option)}
                                            options={optionsClass}
                                        />
                                        {categoryForm.errors.class_subcategory && (
                                            <span className="text-danger">{categoryForm.errors.class_subcategory}</span>
                                        )}
                                    </div>
                                    
                                    <div className="form-group mb-4">
                                        <label className="mb-2">Club</label>
                                        <Select
                                            name="club_subcategory"
                                            value={values.club_subcategory}
                                            onChange={(option) => setFieldValue("club_subcategory", option)}
                                            options={optionsClub}
                                        />
                                        {categoryForm.errors.club_subcategory && (
                                            <span className="text-danger">{categoryForm.errors.club_subcategory}</span>
                                        )}

                                    </div>
                                    
                                    <div className="form-group mb-4">
                                        <label className="mb-2">Quiz</label>
                                        <Select
                                            name="quiz_subcategory"
                                            value={values.quiz_subcategory}
                                            onChange={(option) => setFieldValue("quiz_subcategory", option)}
                                            options={optionsQuiz}
                                        />
                                        {categoryForm.errors.quiz_subcategory && (
                                            <span className="text-danger">{categoryForm.errors.quiz_subcategory}</span>
                                        )}

                                    </div>
                                    
                                    <div className="form-group mb-4">
                                        <label className="mb-2">Competition</label>
                                        <Select
                                            name="competition_subcategory"
                                            value={values.competition_subcategory}
                                            onChange={(option) => setFieldValue("competition_subcategory", option)}
                                            options={optionsCompetition}
                                        />
                                        {categoryForm.errors.competition_subcategory && (
                                            <span className="text-danger">{categoryForm.errors.competition_subcategory}</span>
                                        )}

                                    </div>
                                    <div className="d-flex justify-content-center mt-3">
                                        <button type="submit" className="btn-theme bg-yellow mb-xl-0 mb-3 d-inline-block">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </>
}